//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 25/04/2025
// Version       : 1
// Description   : Editar productos para el reporte de combustibles
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Box,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function EditarProducto({ producto, handleClose, onProductoEditado }) {
  const [datosProducto, setDatosProducto] = useState({
    id: producto.id,
    unidad: producto.unidad ?? null,
  });

  const [unidades, setUnidades] = useState([]);

  // Notificaciones / deshabilitar botón
  const [openSnack, setOpenSnack] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [colormensaje, setColorMensaje] = useState("");
  const [disBtn, setDisBtn] = useState(false);

  // Obtener lista de unidades
  useEffect(() => {
    fetch(UrlApi + "/productos_reporte/unidad")
      .then((r) => r.json())
      .then(setUnidades);
  }, []);

  // Guardar edición
  const guardarEditar = async (e) => {
    e.preventDefault();
    setDisBtn(true);

    // Si id viene vacío o undefined, mando null
    const unidadParaEnviar =
      datosProducto.id === "" || datosProducto.id == null
        ? null
        : datosProducto.id;

    try {
      const res = await fetch(
        `${UrlApi}/productos_reporte/${encodeURIComponent(producto.nombre)}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            unidad: unidadParaEnviar,
          }),
        }
      );
      if (res.ok) {
        setColorMensaje("#D4EFDF");
        setMensaje("Unidad actualizada con éxito");
        setOpenSnack(true);
      } else {
        throw new Error("Error en el servidor");
      }
    } catch (err) {
      setColorMensaje("#F1948A");
      setMensaje("Error al actualizar");
      setOpenSnack(true);
    }
  };

  const almacenar = (e) => {
    setDatosProducto({
      ...datosProducto,
      [e.target.name]: e.target.value,
    });
  };

  const handleCloseSnack = () => {
    setOpenSnack(false);
    setDisBtn(false);
    onProductoEditado();
  };

  return (
    <>
      <Box
        style={{
          borderWidth: 2,
          borderStyle: "solid",
          border: "2px solid #2B76A6",
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 2,
            display: "flex",
            justifyContent: "flex-start", // alineado a la izquierda
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{
              backgroundColor: "#2B76A6",
              borderBottomRightRadius: "12px", // solo esquina inferior derecha
              padding: "8px 18px",
            }}
          >
            Editar
          </Typography>

          <Box
            sx={{
              display: "inline-block",
              backgroundColor: "#F5F5F5",
              padding: "6px",
              borderBottomRightRadius: "12px",
            }}
          >
            <Typography variant="subtitle1">{producto.nombre}</Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <form onSubmit={guardarEditar}>
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel>Unidad</InputLabel>
                  <Select
                    name="id"
                    value={datosProducto.id}
                    label="Unidad"
                    onChange={almacenar}
                  >
                    {unidades.map((unidad) => (
                      <MenuItem key={unidad.id} value={unidad.id}>
                        {unidad.unidad} {"("}
                        {unidad.abreviatura}
                        {")"}{" "}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2} mt={3}>
              <Grid item xs={6}>
                <Button
                  sx={{
                    backgroundColor: "#d32f2f",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#b71c1c", // Rojo más oscuro en hover
                    },
                    "&:disabled": {
                      // Estilo para el botón en estado deshabilitado
                      backgroundColor: "rgba(0, 0, 0, 0.12)", // Color gris estándar de Material-UI
                      color: "rgba(0, 0, 0, 0.26)", // Texto gris estándar
                    },
                  }}
                  variant="contained"
                  onClick={handleClose}
                  disabled={disBtn}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  disabled={disBtn}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      <Stack sx={{ width: "100%" }} spacing={2}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default EditarProducto;
